import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../constants/colors";

const ExamResults = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "#ffffff", // white background
    padding: "20px",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    display: "flex",
    alignItems: "center",
    gap: "16px",
    minHeight: "100px",
    transition: "0.3s",
    cursor: "pointer",
  };

  const iconStyle = {
    fontSize: "32px",
    flexShrink: 0,
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
    marginBottom: "4px",
  };

  const subText = {
    fontSize: "12px", // 12px as requested
    color: colors.grayDark,
    opacity: 0.85,
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  const cards = [
    {
      to: "/exam-datesheet",
      label: "Exam Datesheet",
      icon: "fa-calendar-alt",
      color: colors.primary, 
      text: "View upcoming exam dates and official schedule.",
    },
    {
      to: "/exam-result",
      label: "Results",
      icon: "fa-file-alt",
      color: "#22c55e", // GREEN
      text: "Check your exam results and performance details.",
    },
    {
      to: "/exam-paper",
      label: "Papers",
      icon: "fa-file",
      color: "#a855f7", // PURPLE
      text: "Download previous exam papers for practice.",
    },
  ];

  return (
    <div className="bg-white min-h-screen p-6">
      <div className="max-w-7xl mx-auto">
       

        {/* Grid: 1 mobile, 3 desktop */}
        <div
          className={`grid gap-6 ${
            isMobile ? "grid-cols-1" : "sm:grid-cols-2 lg:grid-cols-3"
          }`}
        >
          {cards.map((card, idx) => (
            <Link to={card.to} key={idx}>
              <div style={cardStyle} className="hover:scale-[1.02] transition">
                <i
                  className={`fas ${card.icon}`}
                  style={{ ...iconStyle, color: card.color }}
                ></i>
                <div>
                  <h2 style={heading}>{card.label}</h2>
                  <p style={subText}>{card.text}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExamResults;
